import { lazy } from 'react';
//import NavbarNotification from "../components/NavbarNotification";

const NavbarNotification = lazy(() =>
  import('../components/NavbarNotification'),
);

const systemNotificationRoute = {
  public: [],
  auth: [
    {
      name: 'system-notification',
      path: '/notification/:customer_code',
      component: NavbarNotification,
    },
  ],
};

export default systemNotificationRoute;
